/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'macbook_dark_large': {
    width: 46,
    height: 54,
    viewBox: '0 0 46 54',
    data: '<path pid="0" d="M42 49V28.5c0-.959-.522-1.5-1.5-1.5h-35c-.978 0-1.5.504-1.5 1.5V49H0c.053.092.127.323.211.323 0 0 2.072 1.248 4.64 1.422 2.566.174 6.144.267 6.149.255.002-.003 12 0 12 0h11s4.638-.084 7.205-.255c2.569-.17 4.61-1.422 4.61-1.422.084 0 .132-.231.185-.323h-4zM6 29h34v20H6V29z" _fill="#efefef"/>'
  }
})
